import { api } from "@/lib/api";

export const CHUNK_SIZE = 1024 * 1024;
export const MAX_FILE_SIZE = 15 * 1024 * 1024;
export const ACCEPTED_TYPES = ["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif", "application/pdf"];
const EXT_TYPES = { jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", webp: "image/webp", heic: "image/heic", heif: "image/heif", pdf: "application/pdf" };

export function detectType(file) {
  if (file.type && file.type !== "application/octet-stream") return file.type.toLowerCase();
  const ext = (file.name.split(".").pop() || "").toLowerCase();
  return EXT_TYPES[ext] || "";
}

export async function compressImage(file, maxPx = 1600, quality = 0.85) {
  const type = detectType(file);
  if (!["image/jpeg", "image/png", "image/webp"].includes(type)) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, maxPx / Math.max(bitmap.width, bitmap.height));
    if (scale === 1 && file.size < 600 * 1024) {
      bitmap.close();
      return file;
    }
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
    if (!blob) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file;
  }
}

export async function uploadFile(rawFile, meta, onProgress) {
  const file = await compressImage(rawFile);
  const content_type = detectType(file);
  const total_chunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  const { data: session } = await api.post("/files/upload/init", { filename: rawFile.name, content_type, size: file.size, total_chunks, ...meta });
  for (let i = 0; i < total_chunks; i++) {
    const chunk = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
    await api.post(`/files/upload/${session.upload_id}/chunk`, chunk, { params: { index: i }, headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.(Math.round(((i + 1) / (total_chunks + 1)) * 100));
  }
  const { data } = await api.post(`/files/upload/${session.upload_id}/complete`);
  onProgress?.(100);
  return data;
}
